import GeneralProvider from './General.provider';

export default GeneralProvider;